<template>
    <div class="page-addtransaction scrollable only-y" v-loading="pageLoading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="page-invoice">
            <div class="toolbar">
                <el-button v-show="userPermissionsFilter.addtransactions" type="primary" icon="el-icon-plus"
                    @click="createTransaction">Add New</el-button>
                <el-button type="warning" class="mb-10 ml-10" icon="el-icon-tickets"
                    v-show="userPermissionsFilter.viewtransactions" @click="viewTransactions">Back to List</el-button>
                <!--<el-button class="animated fadeInRight" plain size="small" @click="printSection('printableDiv')"><i class="mdi mdi-printer"></i> Print</el-button>-->
            </div>

            <iframe height="600" style="width:100%;" v-show="pdfReceipt !== ''" title="Transaction Receipt"
                type="application/pdf" :src="'data:application/pdf;base64,' + pdfReceipt" class="align-vertical-middle">
                Oops,
                your browser doesn't get Iframes. Click <a :href="'data:application/pdf;base64,'+pdfReceipt">Here</a> to
                proceed.</iframe>

            <!--
                <div id="printableDiv">

                    <table mc:repeatable="mainDisplay" width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="full">
                    <tr>
                        <td align="center">
                            <table width="600" border="0" cellspacing="0" cellpadding="0" class="devicewidth">
                                <tr>
                                    <td>
                                        <table width="600" bgcolor="#ffffff" border="0" cellspacing="0" cellpadding="0" align="center" class="full" >
                                            <tr>
                                                <td>
                                                    <table width="600" border="0" cellspacing="0" cellpadding="0" class="full">
                                                        <tr>
                                                            <td align="center">
                                                                <table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="devicewidth">
                                                                    <tr>
                                                                        <td>
                                                                            <table width="600" bgcolor="" border="0" cellspacing="0" cellpadding="20" align="center" class="full" style="margin-top: 0px;">
                                                                                <tr>
                                                                                    <td v-if="!userIsSidianUser" align="left" style="color: #E13328;text-align: left;"><img src="/static/images/upesi-logo.png"></td>
                                                                                    <td v-if="userIsSidianUser" align="left" style="color: #E13328;text-align: left;"><img src="/static/images/sidianLogo.png"></td>
                                                                                    <td align="left" style="font-size: 13px;"><strong style="font-size: 15px;">Upesi MT</strong> <br>info@upesi.co.ke <br><a href="http://upesi.co.ke" target="_blank">http://upesi.co.ke/</a> <br>+254 709656000</td>
                                                                                    <td align="right">
                                                                                        <h4>TRX Time: <span>{{transaction.createdAtStr}}</span></h4>
                                                                                        <h4>TRX Date: <span>{{transaction.createdOnStr}}</span></h4>
                                                                                        <h4>Issued By: <span>{{transaction.createdBy}}</span></h4>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </table>

                                                    <table width="600" border="0" cellspacing="0" cellpadding="0" align="center" style="background-image: url('/static/images/receipt-bg.png');background-repeat: no-repeat;background-position: top;background-size: cover;">
                                                        <tbody>
                                                            <tr>
                                                                <td>

                                                                    <table width="600" border="0"  cellpadding="0" class="full" style="padding: 0px;">
                                                                        <tr>
                                                                            <td><h1>Transaction Type: {{transaction.serviceName}}</h1></td>
                                                                        </tr>
                                                                        <table width="600" border="0" cellspacing="0" cellpadding="20" class="full">
                                                                            <tr>
                                                                                <td>
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Sender’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.senderName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>TELEPHONE NO:</td>
                                                                                            <td>{{transaction.phoneNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>EMAIL:</td>
                                                                                            <td>{{transaction.email}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.countryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>NATIONALITY:</td>
                                                                                            <td>{{transaction.senderNationality}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>OCCUPATION:</td>
                                                                                            <td>{{transaction.senderOccupation}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.documentNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.senderCurrencySymbol}} {{transaction.senderAmountStr}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>CITY:</td>
                                                                                            <td>{{transaction.city}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>SOURCE OF FUNDS:</td>
                                                                                            <td>{{transaction.senderSourceOfFunds}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>
                                                                                <td v-if="transaction.serviceName == 'Bank Deposit'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BANK NAME:</td>
                                                                                            <td>{{transaction.receiverBankName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BRANCH NAME:</td>
                                                                                            <td>{{transaction.receiverBankBranch}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ACCOUNT NUMBER:</td>
                                                                                            <td>{{transaction.receiverBankAccountNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>


                                                                                <td v-if="transaction.serviceName == 'Mobile Money'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>TELEPHONE NO:</td>
                                                                                            <td>{{transaction.receiverPhoneNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>CITY:</td>
                                                                                            <td>{{transaction.receiverCityName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>


                                                                                <td v-if="transaction.serviceName == 'Cash Pickup'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BANK NAME:</td>
                                                                                            <td>{{transaction.receiverBankName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BRANCH NAME:</td>
                                                                                            <td>{{transaction.receiverBankBranch}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ACCOUNT NUMBER:</td>
                                                                                            <td>{{transaction.receiverBankAccountNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>


                                                                            </tr>
                                                                        </table>

                                                                        <tr>
                                                                            <td style="padding: 0 20px;">AMOUNT IN WORDS:  <strong style="color: blue;fontsize: 15px;"> {{ this.senderAmountInWords }} </strong> </td>
                                                                        </tr>
                                                                        <tr v-if="receiverCurrencyIsStronger">
                                                                            <td style="padding: 0 20px;">EXCHANGE RATE:  <strong style="color: blue;fontsize: 15px;">1 {{this.transaction.receiverCurrencySymbol}} =  {{this.inverserate}} {{this.transaction.senderCurrencySymbol}}</strong> </td>
                                                                        </tr>
                                                                        <tr v-else>
                                                                            <td style="padding: 0 20px;">EXCHANGE RATE:  <strong style="color: blue;fontsize: 15px;"> 1 {{this.transaction.senderCurrencySymbol}} = {{this.transaction.exchangeRate}} {{this.transaction.receiverCurrencySymbol}} </strong> </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td style="padding: 0 20px;">CHARGES (inclusive of excise duty):  <strong>{{this.transaction.senderCurrencySymbol}} {{transactionCharges}} </strong> </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td><h1><span>TRX REF NO</span> {{ transaction.referenceNumber }}</h1></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style="padding: 0 20px;">I declare that I agree to the terms and conditions as per <a href="http://upesi.co.ke/terms-use" target="_blank">(http://upesi.co.ke/terms-use)</a></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="20" class="full" style="padding: 30px;">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                            <h4>Customer Signature</h4>

                                                                                        </td>

                                                                                        <td>
                                                                                            <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                            <h4>Agent Signature</h4>
                                                                                        </td>
                                                                                    </tr>

                                                                                </tbody>
                                                                            </table>
                                                                        </tr>

                                                                        <tr v-if="userIsSidianUser">
                                                                            <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="0" class="full">
                                                                                <tr>
                                                                                    <td>
                                                                                        <p>Powered by Upesi</p>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </tr>

                                                                        <tr>
                                                                            <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="0" class="full">
                                                                                <tr>
                                                                                    <td height="18">&nbsp;</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        <img src="/static/images/footer-bg.png" style="width: 100%;">
                                                                                    </td>

                                                                                </tr>
                                                                            </table>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <table width="600" border="0"  cellpadding="0" class="full" bgcolor="#c3d8fd" style="padding: 0px;">
                                                                        <tr>
                                                                            <td><h1>Upesi Copy</h1></td>

                                                                        </tr>
                                                                        <tr>
                                                                            <td><h1>Transaction Type: {{transaction.serviceName}}</h1></td>

                                                                        </tr>

                                                                        <table width="600" border="0" cellspacing="0" cellpadding="20" class="full" bgcolor="#c3d8fd">
                                                                            <tr>
                                                                                <td>
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Sender’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.senderName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>TELEPHONE NO:</td>
                                                                                            <td>{{transaction.phoneNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>EMAIL:</td>
                                                                                            <td>{{transaction.email}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.countryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>NATIONALITY:</td>
                                                                                            <td>{{transaction.senderNationality}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>OCCUPATION:</td>
                                                                                            <td>{{transaction.senderOccupation}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.documentNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.senderCurrencySymbol}} {{transaction.senderAmountStr}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>CITY:</td>
                                                                                            <td>{{transaction.city}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>SOURCE OF FUNDS:</td>
                                                                                            <td>{{transaction.senderSourceOfFunds}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>

                                                                                <td v-if="transaction.serviceName == 'Bank Deposit'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BANK NAME:</td>
                                                                                            <td>{{transaction.receiverBankName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BRANCH NAME:</td>
                                                                                            <td>{{transaction.receiverBankBranch}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ACCOUNT NUMBER:</td>
                                                                                            <td>{{transaction.receiverBankAccountNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>

                                                                                <td v-if="transaction.serviceName == 'Mobile Money'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>TELEPHONE NO:</td>
                                                                                            <td>{{transaction.receiverPhoneNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>CITY:</td>
                                                                                            <td>{{transaction.receiverCityName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>

                                                                                <td v-if="transaction.serviceName == 'Cash Pickup'">
                                                                                    <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                                        <tr><h3>Receiver’s Details</h3></tr>
                                                                                        <tr>
                                                                                            <td>NAME:</td>
                                                                                            <td>{{transaction.receiverName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BANK NAME:</td>
                                                                                            <td>{{transaction.receiverBankName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>BRANCH NAME:</td>
                                                                                            <td>{{transaction.receiverBankBranch}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ACCOUNT NUMBER:</td>
                                                                                            <td>{{transaction.receiverBankAccountNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>COUNTRY:</td>
                                                                                            <td>{{transaction.receiverCountryName}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>ID NO:</td>
                                                                                            <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>AMOUNT:</td>
                                                                                            <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>PURPOSE OF REMITTANCE:</td>
                                                                                            <td>{{transaction.senderPurposeOfRemittance}}</td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </td>

                                                                            </tr>
                                                                        </table>

                                                                        <table width="600" border="0" cellspacing="0" cellpadding="0" class="full" bgcolor="#c3d8fd">

                                                                            <tr>
                                                                                <td style="padding: 0 20px;">AMOUNT IN WORDS: <strong style="color: blue;fontsize: 15px;"> {{ this.senderAmountInWords }}</strong></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td><h1><span>TRX REF NO</span> {{ transaction.referenceNumber }}</h1></td>
                                                                            </tr>

                                                                            <tr>
                                                                                <td style="padding: 0 20px;">I declare that I agree to the terms and conditions as per <a href="http://upesi.co.ke/terms-use" target="_blank">(http://upesi.co.ke/terms-use)</a></td>
                                                                            </tr>
                                                                        </table>


                                                                        <table>
                                                                            <tr>

                                                                                <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="20" class="full" style="padding: 30px;">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                                <h4>Customer Signature</h4>

                                                                                            </td>

                                                                                            <td>
                                                                                                <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                                <h4>Agent Signature</h4>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </tr>

                                                                        <tr v-if="userIsSidianUser">
                                                                            <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="0" class="full">
                                                                                <tr>
                                                                                    <td>
                                                                                        <p>Powered by Upesi</p>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </tr>

                                                                        </table>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
            -->



            <!--
    <table mc:repeatable="mainDisplay" width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="full">
        <tr>
            <td align="center">
                <table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="devicewidth">
                    <tr>
                        <td>
                            <table width="600" bgcolor="#ffffff" border="0" cellspacing="0" cellpadding="0" align="center" class="full" >
                                <tr>
                                    <td>
                                        <table width="600" border="0" cellspacing="0" cellpadding="0" class="full">
                                            <tr>
                                                <td align="center">
                                                    <table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="devicewidth">
                                                        <tr>
                                                        <td>
                                                                <table width="600" bgcolor="" border="0" cellspacing="0" cellpadding="20" align="center" class="full" style="margin-top: 0px;">
                                                                    <tr>
                                                                        <td align="left" style="color: #E13328;text-align: center;">
                                                                            <img :src="transaction.principalCompanyLogo" :alt="transaction.principalCompanyName" style="width: 90px; float: left;">
                                                                            <p style="padding-top:10px;"><b>{{loggedInCompany.name}}</b><br>
                                                                            {{loggedInCompany.email}}<br>
                                                                            {{loggedInCompany.website}}<br>
                                                                            {{loggedInCompany.telephone}}</p>
                                                                        </td>
                                                                        <td align="right">
                                                                            <h4>TRX Time: <span>{{transaction.createdAtStr}}</span></h4>
                                                                            <h4>TRX Date: <span>{{transaction.createdOnStr}}</span></h4>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="table_inner" style="background-image: url('/static/images/receipt-bg.png');background-repeat: no-repeat;background-position: top;background-size: cover;color: #000;">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table width="600" border="0"  cellpadding="30" class="full" style="padding: 30px;">
                                                            <tr>
                                                                <td><h1>Transaction Type: {{transaction.serviceName}}</h1></td>
                                                            </tr>
                                                            <table width="600" border="0" cellspacing="0" cellpadding="20" class="full">
                                                                <tr>
                                                                    <td>
                                                                        <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                            <tr><h3>Senders’ Detail</h3></tr>
                                                                            <tr>
                                                                                <td>NAME:</td>
                                                                                <td>{{transaction.senderName}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>TELEPHONE NO:</td>
                                                                                <td>{{transaction.phoneNumber}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>EMAIL:</td>
                                                                                <td>{{transaction.email}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>COUNTRY:</td>
                                                                                <td>{{transaction.countryName}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>ID NO:</td>
                                                                                <td>{{transaction.documentNumber}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>AMOUNT:</td>
                                                                                <td>{{transaction.senderCurrencySymbol}} {{transaction.senderAmountStr}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>CITY:</td>
                                                                                <td>{{transaction.city}}</td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                    <td>
                                                                        <table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
                                                                            <tr><h3>Receivers’ Detail</h3></tr>
                                                                            <tr>
                                                                                <td>NAME:</td>
                                                                                <td>{{transaction.receiverName}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>TELEPHONE NO:</td>
                                                                                <td>{{transaction.receiverPhoneNumber}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>EMAIL:</td>
                                                                                <td>{{transaction.receiverEmail}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>COUNTRY:</td>
                                                                                <td>{{transaction.receiverCountryName}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>ID NO:</td>
                                                                                <td>{{transaction.receiverDocumentTypeName}} {{transaction.receiverIdNumber}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>AMOUNT:</td>
                                                                                <td>{{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>CITY:</td>
                                                                                <td>{{transaction.receiverCityName}}</td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                            <tr><td height="18">&nbsp;</td></tr>
                                                            <tr>
                                                                <td>
                                                                    <img :src="'/static/images/footer-bg.png'" style="width: 100%;">
                                                                </td>
                                                            </tr>
                                                            <tr><td height="18">&nbsp;</td></tr>
                                                            <tr><td height="18">&nbsp;</td></tr>
                                                            <tr>
                                                                <td class="link">I declare that I agree to the terms and conditions as per <a href="https://upesi.co.ke/terms-conditions/" target="_blank">(https://upesi.co.ke/terms-conditions/)</a></td>
                                                            </tr>
                                                            <tr><td height="18">&nbsp;</td></tr>
                                                            <tr>
                                                                <table width="600" bgcolor="#c3d8fd" border="0"  cellpadding="30" class="full" style="padding: 30px;">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                <h4>Customer Signature</h4>

                                                                            </td>

                                                                            <td>
                                                                                <b class="full" style="padding: 10px;border-bottom: 1px dotted #1a223a;float: left;width: 100%;margin: 0 0 30px 0;"></b>
                                                                                <h4>Agent Signature</h4>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
    -->


        </div>
    </div>
</template>

<script>
import router from '@/router/'
import { bus } from '@/main'
import PermissionsMixins from '@/mixins/PermissionsMixins'

export default {
    name: 'TransactionInvoice',
    data() {
        return {
            pdfReceipt: '',
            referenceNumber: '',
            transaction: {},
            invoiceNumber: '',
            senderAmountInWords: '',
            receiverAmountInWords: '',
            senderAmountInWordsRequest: {},
            recieverAmountInWordsRequest: {},
            userIsSidianUser: false,
            receiverCurrencyIsStronger: false,

            // strongerCurrency: '',
            // weakerCurrency: '',
            inverserate: 0,
            transactionCharges: 0
        }
    },
    computed: {
    },
    methods: {
        printj() {
            var printWindow = window.open("data:application/pdf;base64, " + this.pdfReceipt);
            printWindow.print();
            //window.print()
        },
        printSection(divName) {
            var printContents = document.getElementById(divName).innerHTML;
            var originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;

            window.print();

            document.body.innerHTML = originalContents;
        },
        createTransaction() {
            router.push('/addtransaction');
        },
        viewTransactions() {
            router.push('/transactions');
        }
    },
    mounted() {

    },
    created() {
        this.startLoader("Getting Transaction Receipt ...");
        var id = router.currentRoute.params.id;
        this.GetTransactionReceipt(id)
            .then(result => {
                this.pdfReceipt = result;
                this.stopLoader();
            })
            .catch((err) => {
                this.stopLoader();
                console.log(err);
                this.errorMessage("Transaction record was not found.");
            });

        // this.findTransactionByID(id)
        // .then(result=> {
        // 	this.transaction = result;
        // }).catch(err=> this.errorMessage('Transaction record was not found.'));

        this.getLoggedInCompany();
    },
    mixins: [PermissionsMixins]
}

</script>

<style type="text/css">
@media print {
    body {
        margin-top: 5px;
        margin-left: 10px;
        transform: scale(var(--scale-factor));
        transform-origin: 0 0;
    }
}

div,
p,
a,
li,
td {
    -webkit-text-size-adjust: none;
}

.ReadMsgBody {
    width: 100%;
    background-color: #d1d1d1;

}

.ExternalClass {
    width: 100%;
    background-color: #d1d1d1;
    line-height: 100%;
}

img {
    max-width: 100%;
    width: 100%;
    -ms-interpolation-mode: bicubic;
}

li {
    list-style: none;
    line-height: 20px;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
}

ul {
    padding: 0;
    margin: 0;
}

table[class=full] {
    padding: 0 !important;
    border: none !important;
}

table.receipt-details tr td {
    border: 1px solid #818ea6;
    padding: 9px;
    font-size: 12px;
}

table td img[class=imgresponsive] {
    width: 100% !important;
    height: auto !important;
    display: block !important;

}


h1 {
    font-size: 18px;
    text-transform: uppercase;
    color: #1a2139;
    font-family: 'Open Sans', sans-serif;
    text-align: center;
    padding: 16px 0 0 0;
}

h4 {
    color: #1a2139;
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
}

h5 {
    color: #ff8f31;
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;
}

p {
    color: #1a2139;
    font-family: 'Open Sans', sans-serif;
    text-align: left;
    font-size: 13px;
    padding: 10px 0;
}

a {
    text-align: center;
    color: #1a2139;
    text-transform: uppercase;
    padding: 0px 2px;
    text-decoration: none;
    font-family: 'Open Sans', sans-serif;
    margin: auto;
    /*background-color: #e26500;*/
    font-size: 12px;
    transition: all 0.9s ease;

}

a:hover {
    /*color: #ffffff;*/
    /*background-color:#ffffff;*/
    transition: all 0.9s ease;
    text-decoration: underline;
}

span {
    font-weight: 100;
}

@media only screen and (max-width: 800px) {
    body {
        width: auto !important;

    }

    table[class=full] {
        width: 100% !important;
    }

    table[class=devicewidth] {
        width: 100% !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    table td img.responsiveimg {
        width: 100% !important;
        height: auto !important;
        display: block !important;
    }

}

@media only screen and (max-width: 640px) {

    table[class=devicewidth] {
        width: 100% !important;
    }

    table[class=inner] {
        width: 100% !important;
        text-align: center !important;
        clear: both;
    }

    table td a[class=top-button] {
        width: 160px !important;
        font-size: 14px !important;
        line-height: 37px !important;

    }

    table td[class=readmore-button] {
        text-align: center !important;
    }

    table td[class=readmore-button] a {
        float: none !important;
        display: inline-block !important;
    }

    .hide {
        display: none !important;
    }

    .hidden {
        display: none !important;

    }

    table td[class=smallfont] {
        border: none !important;
        font-size: 22px !important;
    }

    table td[class=sidespace] {
        width: 10px !important;

    }

}


@media only screen and (max-width: 480px) {
    table {
        border-collapse: collapse;
    }

    table td[class=template-img] img {
        width: 100% !important;
        display: block !important;

    }

}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';

.signature {
    border: 0;
    border-bottom: 1px solid #000;
}

.clientlogo2 {
    float: left;
    height: 60px;
    width: 60px;
    box-sizing: border-box;
    border-radius: 50%;
    overflow: hidden;
    background: grey;
    margin-right: 100px;

}

.page-invoice {
    .toolbar {
        max-width: 794px;
        margin: 0 auto;
        text-align: right;
        margin-bottom: 10px;
    }

    .invoice {
        background: white;
        width: 100%;
        max-width: 794px;
        min-height: 1000px;
        margin: 0 auto;
        padding: 2em;
        box-sizing: border-box;
        box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

        hr {
            border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .invoice-top {
            overflow: hidden;
            margin-bottom: 30px;

            .logo {
                float: left;
                height: 70px;
                width: 100px;
                box-sizing: border-box;
                border-radius: 50%;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.07);
                text-align: center;

                img {
                    height: 100%;
                    margin-top: 10%;
                }
            }

            .info {
                display: block;
                float: left;
                margin-left: 20px;
                margin-top: 5px;

                &>* {
                    margin: 0;
                }
            }

            .infoRight {
                display: block;
                float: right;
                margin-right: 20px;
                margin-top: 5px;

                &>* {
                    margin: 0;
                }
            }

            .title {
                float: right;

                &>* {
                    margin: 0;
                }

                p {
                    text-align: right;
                }
            }
        }

        .invoice-middle {
            overflow: hidden;
            margin-top: 0;
            margin-bottom: 0;

            .clientlogo {
                float: left;
                height: 60px;
                width: 60px;
                box-sizing: border-box;
                border-radius: 50%;
                overflow: hidden;
                background: grey;

            }

            .info {
                display: block;
                float: left;
                margin-left: 20px;
                margin-top: 5px;

                &>* {
                    margin: 0;
                }
            }

            .project {
                margin-left: 52%;



                &>* {
                    margin: 0;
                }
            }
        }

        .invoice-bottom {
            table {
                width: 100%;
                border-collapse: collapse;

                th {
                    text-align: right;
                    padding: 10px;
                    padding-bottom: 5px;
                    opacity: .7;

                    &:first-child {
                        text-align: left;
                        padding-left: 0px;
                        width: 100%;
                    }

                    &:last-child {
                        padding-right: 0px;
                    }
                }

                td {
                    text-align: right;
                    padding: 10px;
                    padding-bottom: 5px;
                    border-bottom: 1px solid #EEE;

                    &:first-child {
                        text-align: left;
                        padding-left: 0px;
                        width: 100%;
                    }

                    &:last-child {
                        padding-right: 0px;
                    }
                }

                tfoot td {
                    border: none;
                    padding-top: 5px;
                }
            }
        }

        h1 {
            font-size: 1.5em;
            color: #222;
        }

        h2 {
            font-size: .9em;
        }

        h3 {
            font-size: 1.2em;
            font-weight: 300;
            line-height: 2em;
        }

        p {
            font-size: .7em;
            color: #666;
            line-height: 1.2em;
        }
    }

}


@media screen and (max-width: 768px) {
    .page-invoice {
        .invoice {
            .invoice-middle {
                margin: 0;

                .project {
                    display: block;
                    width: 100%;
                    clear: both;
                    padding: 10px 0;
                    margin: 0;
                }
            }

            .invoice-bottom {
                table {
                    th {
                        padding: 5px;
                    }

                    td {
                        padding: 5px;
                    }
                }
            }
        }
    }
}

@media print {

    .layout-container .container .footer,
    .layout-container .container .header,
    .layout-container .container .horizontal-nav,
    .layout-container .footer,
    .layout-container .layout-picker,
    .layout-container .vertical-nav,
    .layout-container .header {
        display: none;
    }

    .page-invoice {
        .toolbar {
            display: none;
        }

        .invoice {
            box-shadow: none;
            max-width: 100%;
            padding: 0;
        }
    }
}
</style>
